import { apiClient } from '@/shared/api/api.client'

// ─── Type definitions ───────────────────────────────────────────────────────

export interface MasterRecord {
	id: string
	code: string
	label: string
	isActive: boolean
	sortOrder: number
	createdAt: string
	updatedAt: string
}

export interface MasterContractType extends MasterRecord {
	contractTypeId: string
}

export interface MasterGeoLocation extends MasterRecord {
	geoLocationId: string
	countryCode?: string
}

export interface MasterDepartment extends MasterRecord {
	departmentId: string
	parentId?: string | null
	children?: MasterDepartment[]
}

export interface MasterEnvironment extends MasterRecord {
	environmentId: string
}

export interface MasterCloudProvider extends MasterRecord {
	cloudProviderId: string
}

export interface MasterLeadershipType extends MasterRecord {
	leadershipTypeId: string
}

export interface MasterPersonType extends MasterRecord {
	personTypeId: string
}

export type MasterCreateInput = Omit<MasterRecord, 'id' | 'isActive' | 'createdAt' | 'updatedAt'> & {
	countryCode?: string
	parentId?: string | null
}

export type MasterUpdateInput = Partial<Omit<MasterRecord, 'id' | 'createdAt' | 'updatedAt'>> & {
	countryCode?: string
	parentId?: string | null
}

// ─── API surface ────────────────────────────────────────────────────────────

export const masterDataApi = {
	list: async <T>(endpoint: string): Promise<T[]> => {
		const response = await apiClient.get<T[]>(`/employees/master/${endpoint}`)
		if (response.status === 204 || !response.data) return []
		return response.data
	},
	create: async <T>(endpoint: string, data: MasterCreateInput): Promise<T> => {
		const response = await apiClient.post<T>(`/employees/master/${endpoint}`, data)
		return response.data
	},
	update: async <T>(endpoint: string, id: string, data: MasterUpdateInput): Promise<T> => {
		const response = await apiClient.put<T>(`/employees/master/${endpoint}/${id}`, data)
		return response.data
	},
	delete: async (endpoint: string, id: string): Promise<void> => {
		await apiClient.delete(`/employees/master/${endpoint}/${id}`)
	},
}
